import React from 'react';
import { View, StyleSheet } from '../components/Common/react-native-components';
import { Route } from '../components/Router';
import Toast from '../containers/Toast';
import PropTypes from 'prop-types';
import { useTheme } from '@hmsexp/component-library';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'relative'
  }
});

const Home = props => {
  const { palette } = useTheme();
  const Component = props.component;
  const path = props.path;

  return (
    <View style={[styles.container, { backgroundColor: palette.common.white }]}>
      <Route render={props => <Component {...props} />} path={path} />
      <Toast />
    </View>
  );
};


Home.propTypes = {
  activeHotelId: PropTypes.number,
  component: PropTypes.elementType,
  path: PropTypes.string
};

export default Home;
